import { formatDateTime } from 'utils/dateUtils'
import getOne from 'utils/getOne'
import { apiUrls } from 'consts'

const loadDevice = async (id: number | string) => {
  const retData = await getOne(apiUrls.devices, id, [
    'carrier',
    'customer',
    'failure',
    'manufacturer',
    'model',
    'site',
    'type',
    'serviceStatus',
  ]).then((data) => {
    const lastUsedDate: string | null =
      typeof data.last_used_date === 'string'
        ? formatDateTime(new Date(Date.parse(data.last_used_date)))
        : null
    const loadedData = {
      ...data,
      last_used_date: lastUsedDate,
      customer: data?.customer?.name,
    }

    return loadedData
  })

  return retData
}

export default loadDevice
